export default __webpack_public_path__ + "static/media/softlayer.c7a333fd.svg";